import script from "./AddBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBtn.vue?vue&type=script&setup=true&lang=js"

import "./AddBtn.vue?vue&type=style&index=0&id=a9e1b6b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9e1b6b8"]])

export default __exports__